<template>
  <div class="wrap-doctor" @click="enterSaver">
    <!-- 专家分类 -->
    <div
      v-show="!doctorDeatilVis"
      class="container"
      :class="searchVisible ? 'bg2' : ''"
    >
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <!-- 左侧科室菜单 -->
      <div class="doctor-left">
        <!-- 标题 -->
        <div class="title">
          <img src="/images/preloader/icon_zhuangjia.png" alt="" />
          <span>找专家</span>
        </div>
        <!-- 列表 -->
        <div ref="menuList" class="list-wrap">
          <ul class="list">
            <li
              v-for="(item, index) in deptList"
              :key="index"
              :class="
                curSelectDeptIndex === index && searchKey.length === 0
                  ? 'active'
                  : ''
              "
              @click="selectDept(index)"
            >
              {{ item.deptName }}
            </li>
          </ul>
        </div>
        <!-- 上翻下翻按钮 -->
        <div class="btn-group">
          <div @click="scrollHandle('up')">
            <img src="/images/preloader/icon-up.png" alt="" />
            <span>上翻</span>
          </div>
          <div @click="scrollHandle('down')">
            <img src="/images/preloader/icon-down.png" alt="" />
            <span>下翻</span>
          </div>
        </div>
      </div>

      <!-- 中间专家选项 -->
      <div class="doctor-middle">
        <div class="btn-group-top">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_search.png" alt="" /><span
              >拼音查找</span
            >
          </div>
        </div>
        <div class="content">
          <ul v-if="doctorList.length > 0" class="list">
            <li
              v-for="(item, index) in doctorList"
              :key="index"
              :style="(index + 1) % 6 === 0 ? 'margin-right:0' : ''"
              @click="selectDoctorItem(item)"
            >
              <div class="doctor-img">
                <img
                  :src="
                    getImageUrl(item.photo, '/images/preloader/thumbnail2.png')
                  "
                  alt=""
                />
              </div>
              <div class="doctor-name">{{ item.doctorName }}</div>
              <div class="doctor-title">{{ item.jobTitle }}</div>
            </li>
          </ul>
          <noContent v-else></noContent>

          <div v-if="maxPage > 1" class="pagination">
            <div @click="goPage('pre')">
              <img
                style="margin-right:10px"
                src="/images/preloader/icon_lastpage.png"
                alt=""
              /><span>上一页</span>
            </div>
            <div class="num">{{ page }}/{{ maxPage }}</div>
            <div @click="goPage('next')">
              <span>下一页</span
              ><img
                style="margin-left:10px"
                src="/images/preloader/icon_nextpage.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="btn-group">
          <div @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
          <!-- <div @click="searchSwitch"><img src="/images/preloader/icon_foot_search.png" alt=""><span>拼音查找</span></div> -->
        </div>
      </div>

      <!-- 右侧拼音查找 -->
      <div v-show="searchVisible" class="dept-right">
        <div class="title">拼音查找</div>
        <input
          v-model="searchKey"
          class="search-input"
          disabled
          type="text"
          @input="enterSaver"
        />
        <div class="letter-wrap">
          <div
            v-for="(item, index) in letterArr"
            :key="index"
            class="letter"
            @click="inputLetter(item)"
          >
            {{ item }}
          </div>
          <div class="letter letter-del" @click="deleteLetter">
            <img src="/images/preloader/icon_pingyin_deletion.png" alt="" />
            <span>回删</span>
          </div>
        </div>
        <div class="btn-group">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_packup.png" alt="" /><span
              >收起</span
            >
          </div>
          <div class="close-btn" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <div v-if="doctorDeatilVis" class="doctor-detail-mask">
      <!-- 详情盒子 -->
      <div class="doctor-detail">
        <div class="close-icon" @click="closeHandle">
          <span class="el-icon-close"></span>
        </div>
        <!-- 主要内容 -->
        <div class="content">
          <div v-if="curDoctorDetail.doctorId" class="description">
            <!-- 左侧内容 -->
            <div class="description-left">
              <div class="description-left-inner">
                <div class="doctor-img">
                  <img
                    :src="
                      getImageUrl(
                        curDoctorDetail.photo,
                        '/images/preloader/thumbnail2.png'
                      )
                    "
                    alt=""
                  />
                </div>
                <div class="doctor-name">{{ curDoctorDetail.doctorName }}</div>
                <div class="doctor-title">{{ curDoctorDetail.jobTitle }}</div>
                <div class="doctor-dept">
                  {{
                    curDoctorDetail.expertDepId &&
                      deptListObj[curDoctorDetail.expertDepId] &&
                      deptListObj[curDoctorDetail.expertDepId].deptName
                  }}
                </div>
              </div>
            </div>
            <!-- 右侧内容 -->
            <div class="description-right">
              <div class="description-right-main initialOrignUlLi">
                <div
                  class="description-right-main1"
                  v-html="curDoctorDetail.resume"
                ></div>
              </div>
            </div>
          </div>
          <noContent v-else></noContent>
        </div>
        <!-- 分割线 -->
        <img
          v-if="curDoctorDetail.doctorId"
          class="line"
          src="/images/preloader/line_01.png"
        />
        <!-- 底部按钮 -->
        <div class="btn-group">
          <div
            v-if="curDoctorDetail.doctorId"
            class="guahao"
            @click="guahaoHandle"
          >
            <span>显示挂号处位置</span>
          </div>
          <div class="opear">
            <div
              style="margin: 0 0 0 40px;"
              @click="doctorDeatilVis = !doctorDeatilVis"
            >
              <img src="/images/preloader/icon-left.png" alt="" /><span
                >后退</span
              >
            </div>
            <div style="margin: 0 0 0 40px;" @click="closeHandle">
              <img src="/images/preloader/icon_foot_close.png" alt="" /><span
                >关闭</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import noContent from "@/components/no-content";

export default {
  components: {
    noContent
  },
  props: {},
  data() {
    return {
      searchVisible: false, // 拼音搜索显示状态
      searchKey: "", // 拼音搜索关键字
      pinyinSearchList: [], // 拼音搜索结果
      deptList: [], // 科室分类列表
      deptListObj: [], // 科室分类列表对象
      doctorList: [], // 医生专家列表
      curSelectDeptIndex: 0, // 当前选择科室分类下标
      doctorDeatilVis: false, // 详情展示
      limit: 12, // 专家分页-条数
      page: 1, // 专家分页-页数
      maxPage: 1, // 专家分页-最大页数
      curExpertDepId: null, // 当前科室
      curDoctorDetail: {}
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get() {
        return this.$store.state.nav.buildInfo;
      },
      set(val) {
        this.$store.commit("nav/set_buildInfo", val);
      }
    },
    ...mapState("app", ["letterArr"])
  },
  watch: {
    async searchKey(val) {
      this.pinyinSearch(val);
    }
  },
  async created() {
    let deptRes = await this.getDeptList();
    console.log("获取科室列表", deptRes);
    this.deptList = deptRes;
    // 初始选择第一个科室
    if (this.deptList.length > 0) {
      this.deptList.forEach(element => {
        this.deptListObj[element.expertDepId] = element;
      });
      this.selectDept(0);
    }
  },
  mounted() {},
  methods: {
    ...mapActions("nav", [
      // 调用定时器
      "enterSaver"
    ]),
    // 获取图片文件地址
    getImageUrl(url, defaultUrl) {
      try {
        if (url) {
          return url;
        } else {
          return defaultUrl;
        }
      } catch (error) {
        console.error("获取动态图片报错");
        return defaultUrl;
      }
    },
    // 选择科室
    async selectDept(index) {
      // 清空搜索条件
      this.searchKey = "";
      this.page = 1;
      // 选中科室
      this.curSelectDeptIndex = index;
      // 当前科室id
      this.curExpertDepId = this.deptList[index]["expertDepId"];
      // 请求数据
      let res = await this.getDoctorList();
      console.log("专家列表", res);
      // 赋值数据
      this.doctorList = res;
    },
    // 选择医生
    async selectDoctorItem(data) {
      this.curDoctorDetail = await this.getDoctorDetail(data.doctorId);
      this.doctorDeatilVis = true;
    },
    // 上翻下翻
    scrollHandle(type) {
      console.log(this.$refs.menuList.scrollTop);
      let scrollTop = this.$refs.menuList.scrollTop;
      if (type === "up") {
        this.$refs.menuList.scrollTop = scrollTop - 600;
      } else {
        this.$refs.menuList.scrollTop = scrollTop + 600;
      }
    },
    // 左右翻页
    async goPage(type) {
      if (type === "pre") {
        if (this.page === 1) {
          this.page = 1;
          return;
        } else {
          this.page--;
        }
      } else if (type === "next") {
        if (this.page === this.maxPage) {
          this.page = this.maxPage;
          return;
        } else {
          this.page++;
        }
      }
      let res = await this.getDoctorList();
      console.log("专家列表", res);
      // 赋值数据
      this.doctorList = res;
    },
    // 拼音搜索开关
    searchSwitch() {
      this.searchVisible = !this.searchVisible;
    },
    // 输入字母
    inputLetter(letter) {
      this.searchKey += letter;
    },
    // 删除字母
    deleteLetter() {
      if (this.searchKey.length > 0) {
        console.log(123123);
        this.searchKey = this.searchKey.substr(0, this.searchKey.length - 1);
      }
    },
    // 挂号
    guahaoHandle() {
      this.$emit("guahao");
    },
    // 关闭专家窗口
    closeHandle() {
      this.$emit("close");
    },
    // 获取科室列表
    async getDeptList(buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.third.getexpertDeptList({
          buildId
        });
        let data = JSON.parse(res.data);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 获取专家列表
    async getDoctorList() {
      try {
        let res = await this.$apis.third.getExpertDoctorQueryPage({
          buildId: this.buildInfo.buildId,
          expertDepId:
            this.curExpertDepId && !this.searchKey
              ? this.transferType(this.curExpertDepId, "String")
              : null,
          limit: this.limit,
          page: this.page,
          doctorName: this.searchKey
        });
        let data = JSON.parse(res.data);
        this.maxPage = data.totalPage;
        return data.list;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    // 判断对错并且转化为对应类型
    transferType(data, type) {
      console.log("判断对错并且转化为对应类型", data, type);
      // 判断转化数据是否为空
      let res;
      if (data) {
        res = data;
      } else {
        res = null;
        return res;
      }
      // 判断类型
      switch (type) {
        case "String":
          res = String(res);
          break;
        case "Number":
          res = Number(res);
          break;
        // 后期话类型再添加
        default:
          break;
      }
      console.log("判断对错并且转化为对应类型", res);
      return res;
    },
    // 专家医生详情
    async getDoctorDetail(doctorId) {
      try {
        let res = await this.$apis.third.getExpertDoctorDetail({
          buildId: this.buildInfo.buildId,
          doctorId: doctorId
        });
        let data;
        if (res.data) {
          // 判断data是否存在,如果data不存在,则返回空对象,防止差值表达式报错
          data = JSON.parse(res.data);
        } else {
          data = {};
        }
        return data;
      } catch (error) {
        console.error("获取专家医生详情报错信息", error);
        return {};
      }
    },
    // // 拼音搜索
    async pinyinSearch(search) {
      console.log("搜索值:", search);
      this.page = 1;
      let res = await this.getDoctorList();
      this.doctorList = res;
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-doctor {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: $color-opacity-regular;

  //科室列表
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 819px;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 5px 10px 12px 8px;
    box-sizing: border-box;
  }
  .close-icon {
    display: none;
  }
  .bg2 {
    background: url("/images/preloader/bg-symptom2.png") no-repeat;
    background-size: 100% 100%;
  }
  .doctor-left {
    width: 294px;
    color: $color-white;
    .title {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      img {
        margin: 0 10px 0 0;
      }
    }
    .list-wrap {
      height: calc(100% - 220px);
      overflow: auto;
      .list {
        list-style: none;
      }
      li {
        font-size: 26px;
        height: 70px;
        line-height: 70px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .active {
        background: #386998;
        color: #40e9ad;
        border-left: 5px solid #40e9ad;
      }
    }
    .btn-group {
      flex: 0 0 wrap;
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: space-evenly;
      & > div {
        width: 100px;
        height: 40px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        border-radius: 50px;
        // margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 10px 0 0;
        width: 24px;
      }
    }
  }
  .doctor-middle {
    width: 1160px;
    padding: 40px 0 40px 40px;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .content {
      height: 100%;
      position: relative;
      .pagination {
        position: absolute;
        bottom: 22px;
        left: 50%;
        margin-left: -162px;
        display: flex;
        & > div {
          width: 109px;
          height: 40px;
          background: #3a6191;
          box-shadow: 0 0 10px $color-opacity-primary;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          border-radius: 50px;
          // margin: 0 40px 0 0;
          color: $color-white;
        }
        & .num {
          background: transparent;
          box-shadow: none;
        }
        img {
          width: 11px;
        }
      }
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    li {
      width: 152px;
      height: 270px;
      margin-right: 34px;
      margin-bottom: 29px;
      box-sizing: border-box;
      text-align: center;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      & > .doctor-img {
        height: 190px;
        width: 152px;
        margin-bottom: 17px;
        img {
          height: 100%;
          border-radius: 10px;
        }
      }
      & > .doctor-name {
        margin-bottom: 9px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #fff;
      }
      & > .doctor-title {
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }

      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
    .btn-group-top {
      position: relative;
      display: flex;
      padding-bottom: 40px;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .doctor-detail-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: $color-opacity-primary;
    z-index: 999999;
    .doctor-detail {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1510px;
      height: 819px;
      transform: translate(-50%, -50%);
      background: url("/images/preloader/bg-symptom3.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      padding: 45px 50px 0 48px;
      box-sizing: border-box;
      flex-direction: column;
      text-align: left;
      color: $color-white;
      .title {
        font-size: 36px;
        margin: 0 0 20px 0;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & > .content {
        height: 640px;
        width: 100%;
        font-size: 24px;
        // text-indent: 2em;
        .description {
          display: flex;
          height: 100%;
          overflow: auto;
          font-size: 24px;
          .description-left {
            position: relative;
            width: 291px;
            .description-left-inner {
              width: 248px;
              text-align: center;
              .doctor-img {
                width: 248px;
                height: 340px;
                overflow: hidden;
                border-radius: 20px;
                margin-bottom: 30px;
                img {
                  height: 340px;
                }
              }
              .doctor-name {
                margin-bottom: 25px;
                font-size: 32px;
              }
              .doctor-title {
                margin-bottom: 16px;
                font-size: 20px;
              }
              .doctor-dept {
                font-size: 20px;
              }
            }
          }
          .description-right {
            flex: 1;
            padding-left: 35px;
            // line-height: 40px;
            // letter-spacing: 1px;
            overflow: auto;
            .description-right-main {
              flex: initial;
              padding-left: initial;
              overflow: initial;
              font-size: initial;
              line-height: initial;
            }
          }
        }
      }
      .line {
        position: absolute;
        top: 0;
        left: 339px;
      }
      .btn-group {
        display: flex;
        height: 120px;
        align-items: center;
        justify-content: space-between;
        & .guahao {
          width: 230px;
          height: 60px;
          background: #3a6191;
          box-shadow: 0 0 10px $color-opacity-primary;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 26px;
          border-radius: 50px;
          color: $color-white;
          background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
        }
        & .opear {
          display: flex;
          & > div {
            width: 180px;
            height: 60px;
            background: #3a6191;
            box-shadow: 0 0 10px $color-opacity-primary;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 26px;
            border-radius: 50px;
            color: $color-white;
          }
          img {
            margin: 0 20px 0 0;
            width: 24px;
          }
        }
      }
    }
  }

  .dept-right {
    position: relative;
    width: 385px;
    margin: 40px 0 40px 0;
    border-left: 1px solid #618aaf;
    .title {
      font-size: 28px;
      color: $color-white;
      width: 306px;
      margin: 0 auto 40px;
      text-align: left;
    }
    .search-input {
      border: 1px solid #618aaf;
      border-radius: 10px;
      width: 306px;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      text-align: left;
      color: $color-white;
      font-size: 26px;
      padding: 0 20px;
      box-sizing: border-box;
      background: transparent;
    }
    .letter-wrap {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #618aaf;
      border-radius: 10px;
      overflow: hidden;
      width: 306px;
      margin: 10px auto 0;
      .letter {
        width: 50px;
        height: 50px;
        line-height: 50px;
        // box-sizing: border-box;
        margin: -1px 0 0 -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        border: 1px solid #618aaf;
        color: $color-white;
        &.letter-del {
          flex: 1;
        }
        &:hover {
          background: #345b85;
        }
        img {
          margin: 0 10px 0 0;
        }
      }
    }
    .btn-group {
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      justify-content: center;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      .close-btn {
        display: none;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .doctor-detail-test {
    //保留上一版本css代码,方便调用参考
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1472px;
    height: 819px;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 45px 50px 52px 48px;
    box-sizing: border-box;
    flex-direction: column;
    text-align: left;
    color: $color-white;
    .title {
      font-size: 36px;
      margin: 0 0 20px 0;
      height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      height: 600px;
      width: 100%;
      font-size: 24px;
      text-indent: 2em;
    }
    .description {
      height: 100%;
      overflow: auto;
      line-height: 50px;
      font-size: 24px;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
      }
      .guahao {
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(to bottom, #40e9ad 0%, #03af6c 100%);
      }
    }
  }
}

.deptPop-test {
  height: 660px;
  padding: 20px 0;
  box-sizing: border-box;
  .content {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .dept-wrap {
    margin: 0 0 20px 0;
    .dept-cate {
      font-size: 36px;
      color: #fff;
      text-align: left;
      margin: 0 0 20px 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .dept-list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    .dept-li {
      width: 258px;
      height: 98px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 5px 20px 10px 18px;
      margin: 0 17.5px 20px;
      text-align: center;
      background: url("/images/preloader/btn-bg1.png");
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
@media (orientation: portrait) {
  .wrap-doctor {
    .container {
      height: 68vh;
      padding: 0;
      // background-size: auto 100%;
      background: rgba(46, 90, 141, 0.94);
      border-radius: 20px;
    }
    .close-icon {
      display: block;
      position: absolute;
      top: -60px;
      right: 0;
      font-size: 38px;
      color: #ccc;
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-radius: 50%;
      border: 2px solid #ccc;
      padding: 0;
      font-weight: bold;
      box-sizing: border-box;
    }
    .doctor-middle {
      background: #476f9b;
      border-radius: 0 20px 20px 0;
      .content {
        height: calc(100% - 620px);
      }
      .list {
        height: max-content;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(4, calc(25% - 2.22vw));
        grid-gap: 2.22vw 2.22vw;
        li {
          width: 100%;
          height: max-content;
          margin: 0;
        }
        .doctor-img {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
        .doctor-name {
          width: 100%;
          text-align: center;
          font-size: 2.59vw;
        }
        .doctor-title {
          width: 100%;
          text-align: center;
          font-size: 2.22vw;
        }
      }
      .btn-group {
        display: none;
      }
      .btn-group-top {
        display: none;
      }
    }
    .doctor-left {
      .btn-group {
        & > div {
          width: 120px;
          height: 50px;
          // font-size: 20px;
        }
        .close-btn {
          display: none;
        }
      }
      .list-wrap {
        .list {
          li {
            // padding: 0.74vw 0.74vw;
            // font-size: 2.59vw;
          }
        }
      }
    }
    .dept-right {
      position: absolute;
      margin: 0;
      height: 600px;
      width: 1160px;
      bottom: 0;
      right: 0;
      display: block !important;
      border: 0;
      .title {
        text-align: center;
        margin: 0 auto 10px;
      }
      .search-input {
        width: 936px;
        height: 70px;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .letter-wrap {
        width: 936px;
        .letter {
          width: 70px;
          height: 70px;
          font-size: 30px;
          img {
            width: 20px;
          }
        }
      }
      .btn-group {
        position: absolute;
        right: 30px;
        left: auto;
        bottom: 40px;
        width: 200px;
        div:nth-of-type(1) {
          display: none;
        }
        .close-btn {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .doctor-detail-mask {
      .doctor-detail {
        height: 68vh;
        background: rgba(46, 90, 141, 0.94);
        border-radius: 20px;
        .content {
          height: 100%;
          color: #fff;
        }
      }
    }
  }
}
</style>
